// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusLevelsList_wrapper__iCT0D","title":"StatusLevelsList_title__5pC7G","list":"StatusLevelsList_list__WUrSp","divider":"StatusLevelsList_divider__liS-J"};